import * as DashboardService from '@/services/apis/dashboard'
const state = {
}

const actions = {
    async dashboardToday({ }) {
        try {
          const res = await DashboardService.dashboardToday()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardMemberInfo({ }) {
        try {
          const res = await DashboardService.dashboardMemberInfo()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardAccountbank({ }) {
        try {
          const res = await DashboardService.dashboardAccountbank()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardDeposit({ }) {
        try {
          const res = await DashboardService.dashboardDeposit()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardWithdraw({ }) {
        try {
          const res = await DashboardService.dashboardWithdraw()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardDaily({ }) {
        try {
          const res = await DashboardService.dashboardDaily()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardMonthly({ }) {
        try {
          const res = await DashboardService.dashboardMonthly()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardMonthlyV2({ }) {
        try {
          const res = await DashboardService.dashboardMonthlyV2()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      async dashboardAffiliateTotalPlay({ }, params) {
        try {
          const res = await DashboardService.dashboardAffiliateTotalPlay(params)
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
      /**
       * ============================================
       * DASHBOARD DAILY OPTIONS
       * ============================================
       * ดึงตัวเลือก dropdown สำหรับเลือกเดือนย้อนหลัง
       * 
       * API: GET /admin/dashboard/daily/options
       * 
       * Response:
       * {
       *   options: [{ text: "พ.ย. 2568", value: { year: 2025, month: 11 } }, ...],
       *   default: { year: 2025, month: 11 }
       * }
       * 
       * Called by: Dashboard.vue → fetchDailyOptions()
       */
      async dashboardDailyOptions({ }) {
        try {
          const res = await DashboardService.dashboardDailyOptions()
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },

      /**
       * ============================================
       * DASHBOARD DAILY BY MONTH
       * ============================================
       * ดึงข้อมูลสรุปรายวันของเดือนที่เลือก
       * 
       * API: GET /admin/dashboard/daily/by-month?year=2025&month=10
       * 
       * @param {Object} params - พารามิเตอร์
       * @param {number} params.year - ปี เช่น 2025
       * @param {number} params.month - เดือน 1-12
       * 
       * Response: Array ของข้อมูลรายวัน
       * [{ day, active_users, deposit, withdraw, profit }, ...]
       * 
       * Called by: Dashboard.vue → onDailyMonthChange()
       */
      async dashboardDailyByMonth({ }, params) {
        try {
          const res = await DashboardService.dashboardDailyByMonth(params)
          return res.data
        } catch (err) {
          if(err.message){ throw JSON.parse(err.message) }
        }
      },
}

export default {
    state,
    actions,
  }
